import { protectedRoutes } from '../../../../constants/routes';
import TopicLoading from './topic-loading.component';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { fetchListRecommendedTopics } from '../../../../apis/discovery.api';
import { useState } from 'react';
import { useAtomValue } from 'jotai';
import { profileAtom } from '../../../Settings/atom';

const RecommendedTopics = () => {
  const navigate = useNavigate();
  const [listRecommendedTopics, setListRecommendedTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const profile = useAtomValue(profileAtom);

  const handleRedirectToRecommendTopics = (id) => {
    navigate(`${protectedRoutes.RECOMMEND_TOPICS}?topicId=${id}`);
  };

  useEffect(() => {
    const getRecommendedTopics = async () => {
      try {
        const result = await fetchListRecommendedTopics({
          page: 1,
          limit: 5,
          userId: profile.id
        });
        setListRecommendedTopics(result);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    getRecommendedTopics();
  }, []);

  return (
    <div className="">
      <h1 className="text-base !text-earth-brown-500 font-[800] mb-[24px]">Recommended Topics</h1>
      {loading && <TopicLoading />}
      <div className="w-[100%] 2xl:gap-[16px]">
        {listRecommendedTopics?.map((item) => (
          <div
            key={item.id}
            className="mb-2 flex items-center hover:opacity-70 transition duration-200 cursor-pointer w-fit text-sm"
            onClick={() => {
              handleRedirectToRecommendTopics(item.id);
            }}
          >
            <div>
              <p className="inline !text-earth-brown-500 font-[800]">{item.name}</p>
              <p className="inline !text-[#BAAEA8] ml-1">{`(${item.total || 0})`}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecommendedTopics;
